//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { AddSubscriptionSector } from './models/AddSubscriptionSector';
import type { SubscriptionSector } from './models/SubscriptionSector';
import { Utilities } from './Utilities';

export class SubscriptionSectorsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        get: (): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        post: (): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deleteById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v1/subscription-sectors/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all subscription sectors.
     * @return OK
     * @deprecated
     */
    async get(): Promise<SubscriptionSector[]> {
        const clientRequestUrl = this.baseUrl + this.routes.get();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SubscriptionSector[]>(_response, false, []);
    }

    /**
     * Add a new subscription sector.
     * @param body (optional) The subscription sector to add
     * @return Created
     * @deprecated
     */
    async post(
        body?: AddSubscriptionSector,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.post();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }

    /**
     * Retrieves the specified subscription sector.
     * @param id The subscription sector id
     * @return OK
     * @deprecated
     */
    async getById(
        id: number,
    ): Promise<SubscriptionSector> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SubscriptionSector>(_response, false, []);
    }

    /**
     * Delete the specified subscription sector.
     * @param id The subscription sector id
     * @deprecated
     */
    async deleteById(
        id: number,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deleteById(
            id,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
